(function() {
    'use strict';

    angular.module('user.constants', [])
        .constant('userPermissionsConst', {
            anonymous: 'anonymous',
            user: 'user'
        })
        .constant('userRedirectConst', {
            afterLogin: 'layout.home',
            afterLogout: 'login.username',
            onTokenResponseError: 'login.username',
            ifAnonymous: 'login.username',
            ifUser: 'layout.home',
            modelPermissionReject: 'layout.home'
        })
        .constant('adminMessagesConst', {
            update: 'Dane użytkownika zostały zaktualizowane!',
            delete: 'Użytkownik został usunięty!',
            add: 'Dodano nowego użytkownika!',
            error: 'Wystąpił bład!'
        })
        .constant('adminPermissionsConst', {
            view: {
                value: 'view_admin',
                errorMsg: 'Użytkownik nie ma uprawnień do odczytu administratorów!'
            },
            add: {
                value: 'add_admin',
                errorMsg: 'Użytkownik nie ma uprawnień do dodania administratorów!'
            },
            update: {
                value: 'change_admin',
                errorMsg: 'Użytkownik nie ma uprawnień do edycji administratorów!'
            },
            delete: {
                value: 'delete_admin',
                errorMsg: 'Użytkownik nie ma uprawnień do usuwania administratorów!'
            }
        })
        .constant('modelPermissionsGroupMessagesConst', {
            update: 'Dane grupy zostały zaktualizowane!',
            delete: 'Grupa została usunięta!',
            add: 'Dodano nową grupę!',
            error: 'Wystąpił bład!'
        })
        .constant('modelPermissionsGroupPermissionsConst', {
            view: {
                value: 'view_group',
                errorMsg: 'Użytkownik nie ma uprawnień do odczytu grup!'
            },
            add: {
                value: 'add_group',
                errorMsg: 'Użytkownik nie ma uprawnień do dodania grup!'
            },
            update: {
                value: 'change_group',
                errorMsg: 'Użytkownik nie ma uprawnień do edycji grup!'
            },
            delete: {
                value: 'delete_group',
                errorMsg: 'Użytkownik nie ma uprawnień do usuwania grup!'
            }
        })
        .constant('clientMessagesConst', {
            update: 'Dane klienta zostały zaktualizowane!',
            delete: 'Klient został usunięty!',
            add: 'Dodano nowego klienta!',
            activated: 'Konto klienta zostało pomyslnie aktywowane!',
            error: 'Wystąpił bład!'
        })
        .constant('clientPermissionsConst', {
            view: {
                value: 'view_client',
                errorMsg: 'Użytkownik nie ma uprawnień do odczytu klientów!'
            },
            add: {
                value: 'add_client',
                errorMsg: 'Użytkownik nie ma uprawnień do dodania klientów!'
            },
            update: {
                value: 'change_client',
                errorMsg: 'Użytkownik nie ma uprawnień do edycji klientów!'
            },
            delete: {
                value: 'delete_client',
                errorMsg: 'Użytkownik nie ma uprawnień do usuwania klientów!'
            }
        })
        .constant('allowedIpMessagesConst', {
            update: 'Dane IP zostały zaktualizowane!',
            delete: 'IP został usunięty!',
            add: 'Dodano nowy IP!',
            error: 'Wystąpił bład!'
        })
        .constant('allowedIpPermissionsConst', {
            view: {
                value: 'view_allowedip',
                errorMsg: 'Użytkownik nie ma uprawnień do odczytu IP!'
            },
            add: {
                value: 'add_allowedip',
                errorMsg: 'Użytkownik nie ma uprawnień do dodania IP!'
            },
            update: {
                value: 'change_allowedip',
                errorMsg: 'Użytkownik nie ma uprawnień do edycji IP!'
            },
            delete: {
                value: 'delete_allowedip',
                errorMsg: 'Użytkownik nie ma uprawnień do usuwania IP!'
            }
        })
        .constant('discountGroupMessagesConst', {
            update: 'Dane grupy rabatowej zostały zaktualizowane!',
            delete: 'Grupa rabatowa została usunięty!',
            add: 'Dodano nową grupę rabatową!',
            error: 'Wystąpił bład!'
        })
        .constant('discountGroupPermissionsConst', {
            view: {
                value: 'view_discountgroup',
                errorMsg: 'Użytkownik nie ma uprawnień do odczytu grup rabatowych!'
            },
            add: {
                value: 'add_discountgroup',
                errorMsg: 'Użytkownik nie ma uprawnień do dodania grup rabatowych!'
            },
            update: {
                value: 'change_discountgroup',
                errorMsg: 'Użytkownik nie ma uprawnień do edycji grup rabatowych!'
            },
            delete: {
                value: 'delete_discountgroup',
                errorMsg: 'Użytkownik nie ma uprawnień do usuwania grup rabatowych!'
            }
        });
})();
